var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 2C11.6266 2 9.30655 2.70379 7.33316 4.02236C5.35977 5.34094 3.8217 7.21508 2.91345 9.4078C2.0052 11.6005 1.76756 14.0133 2.23058 16.3411C2.6936 18.6689 3.83649 20.807 5.51472 22.4853C7.19295 24.1635 9.33115 25.3064 11.6589 25.7694C13.9867 26.2324 16.3995 25.9948 18.5922 25.0865C20.7849 24.1783 22.6591 22.6402 23.9776 20.6668C25.2962 18.6934 26 16.3734 26 14C26 10.8174 24.7357 7.76515 22.4853 5.51472C20.2348 3.26428 17.1826 2 14 2ZM14 3.71429C16.4314 3.71465 18.7832 4.58064 20.6343 6.15714L6.15715 20.6343C4.89359 19.1373 4.08382 17.3105 3.82309 15.3689C3.56236 13.4274 3.86151 11.4517 4.68536 9.67439C5.5092 7.89704 6.82347 6.39193 8.47358 5.33609C10.1237 4.28024 12.041 3.71758 14 3.71429ZM14 24.2857C11.5686 24.2853 9.21676 23.4194 7.36572 21.8429L21.8514 7.35714C23.1181 8.85455 23.9302 10.6829 24.1921 12.6266C24.454 14.5704 24.1547 16.5484 23.3295 18.3277C22.5043 20.1069 21.1876 21.6131 19.5346 22.6688C17.8816 23.7244 15.9613 24.2854 14 24.2857Z",
    fill: "#FC5719"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.814cae357d6eababb83779ce9a23b6cc.svg";
export { ForwardRef as ReactComponent };